import { resolveReportImageSource } from './reportBind.util'

export const applyTextEditorImageSource = ({
  attributeName,
  attributeValue,
  element,
  keepMissingTokens = false,
  nextAttributeValue,
}) => {
  const isTokenizedImageSource =
    attributeName === 'src' &&
    element?.nodeName === 'IMG' &&
    /\{[^}]+\}/.test(attributeValue || '')

  if (!isTokenizedImageSource) return false

  const imageSource = resolveReportImageSource(nextAttributeValue)

  if (imageSource) {
    element.setAttribute(attributeName, imageSource)
  } else if (!keepMissingTokens) {
    element.removeAttribute(attributeName)
  } else if (nextAttributeValue !== attributeValue) {
    element.setAttribute(attributeName, nextAttributeValue)
  }

  return true
}
